import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useTariffTypes } from '../../hooks';
import type { TariffType, TariffTypeFilters } from '../../models';

export interface TariffTypeFieldProps extends Omit<SelectProps<TariffType>, 'options'> {
  defaultFilters?: Partial<TariffTypeFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<TariffType>['errorMessage'];
  isInvalid?: boolean;
}

export const TariffTypeField: React.FC<TariffTypeFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useTariffTypes(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
